module.exports = __webpack_public_path__ + "img/image-about-us-03-academy-template.1d3953c2.jpg";